var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 15.75C14.4164 15.75 16.3751 13.7912 16.3751 11.375C16.3751 8.95875 14.4164 7 12.0001 7C9.58388 7 7.62512 8.95875 7.62512 11.375C7.62512 13.7912 9.58388 15.75 12.0001 15.75ZM12.0001 15.75C9.45371 15.75 7.22487 16.7698 6 18.2945M12.0001 15.75C14.5465 15.75 16.7754 16.7698 18.0002 18.2945M7.09259 2H16.9074C17.2654 2 17.5556 2.2922 17.5556 2.65264C17.5556 4.45487 19.0065 5.91586 20.7963 5.91586H21.2593C21.6684 5.91586 22 6.2498 22 6.66173V7.62235C22 13.8198 18.6632 19.5301 13.283 22.5398L12.8627 22.7749C12.3262 23.075 11.6738 23.075 11.1373 22.7749L10.717 22.5398C5.33681 19.5301 2 13.8198 2 7.62235V6.66174C2 6.2498 2.33164 5.91586 2.74074 5.91586H3.2037C4.99352 5.91586 6.44444 4.45487 6.44444 2.65264C6.44444 2.2922 6.73463 2 7.09259 2Z",
    stroke: "#C1C5D6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.06c7af4222452a792b7553fd0dda8c37.svg";
export { ForwardRef as ReactComponent };